import { useEffect, useState } from 'react';
import { getSubscription, Tier } from '../api/paymentsApi';
import { useAuth } from '../auth/AuthContext';

export interface Entitlements {
  tier: Tier;
  hasBasic: boolean;
  hasPro: boolean;
  adFree: boolean;
  loading: boolean;
  refresh: () => void;
}

// Derives the user's tier and entitlement flags from the subscription. Paid tiers
// are ad-free; the free tier is ad-supported.
export function useEntitlements(): Entitlements {
  const { userId, isAuthenticated } = useAuth();
  const [tier, setTier] = useState<Tier>('free');
  const [loading, setLoading] = useState(true);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let cancelled = false;
    if (!isAuthenticated || !userId) {
      setTier('free');
      setLoading(false);
      return;
    }
    setLoading(true);
    getSubscription(userId)
      .then((sub) => {
        if (!cancelled) setTier(sub.tier);
      })
      .catch(() => {
        if (!cancelled) setTier('free');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [userId, isAuthenticated, nonce]);

  const hasBasic = tier === 'basic' || tier === 'pro';
  const hasPro = tier === 'pro';
  return {
    tier,
    hasBasic,
    hasPro,
    adFree: hasBasic,
    loading,
    refresh: () => setNonce((n) => n + 1),
  };
}
